import React from 'react';
import { Box, Chip, LinearProgress, Paper, Stack, Typography } from '@mui/material';
import { KpiVisitasDto } from '../../../types/visitas';

interface VisitasProgressKpiProps {
  value?: KpiVisitasDto;
}

const defaultValue: KpiVisitasDto = {
  total: 0,
  pendientes: 0,
  iniciadas: 0,
  completadas: 0,
  omitidas: 0,
  avancePorcentaje: 0,
};

const clampPercent = (value: number): number => {
  if (!Number.isFinite(value)) return 0;
  return Math.max(0, Math.min(100, value));
};

const VisitasProgressKpi: React.FC<VisitasProgressKpiProps> = ({ value }) => {
  const kpi = value ?? defaultValue;
  const percent = clampPercent(kpi.avancePorcentaje);

  return (
    <Paper variant="outlined" sx={{ p: 1, borderRadius: 1.5 }}>
      <Stack spacing={0.75}>
        <Typography variant="caption" color="text.secondary">
          Visitas
        </Typography>
        <Box display="flex" justifyContent="space-between" alignItems="baseline">
          <Typography variant="body2" fontWeight={700}>
            {kpi.completadas}/{kpi.total}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {percent.toFixed(0)}%
          </Typography>
        </Box>
        <LinearProgress variant="determinate" value={percent} sx={{ height: 7, borderRadius: 999 }} />
        <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
          <Chip size="small" label={`Pend ${kpi.pendientes}`} sx={{ bgcolor: 'grey.100' }} />
          <Chip size="small" label={`Ini ${kpi.iniciadas}`} sx={{ bgcolor: 'warning.light' }} />
          <Chip size="small" label={`Comp ${kpi.completadas}`} sx={{ bgcolor: 'success.light' }} />
          <Chip size="small" label={`Omi ${kpi.omitidas}`} sx={{ bgcolor: 'error.light' }} />
        </Stack>
      </Stack>
    </Paper>
  );
};

export default VisitasProgressKpi;
